import { usePortfolioToggle } from '@/composables/usePortfolioToggle';

export default {
  name: 'PortfolioToggleButton',

  props: {
    portfolioType: {
      type: String,
      required: true,
      validator: (value) => ['innovation', 'water-saving'].includes(value),
    },
  },

  emits: ['filter-change'],

  setup(props) {
    return usePortfolioToggle(props.portfolioType);
  },
};